import { connect } from 'react-redux';
import * as applicantActions from '../../redux/actions/applicantActions';

export default (WrappedComponent) => connect(null, applicantActions)(WrappedComponent);
